import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f62754f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative text-primary-black" }
const _hoisted_2 = { class: "w-full rounded-xl" }
const _hoisted_3 = { class: "absolute font-bold pl-10 pt-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "workbean-arrow-down w-5 h-5" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "relative cursor-default select-none py-2 px-2 text-gray-700"
}
const _hoisted_6 = ["onClick"]

import { ref, computed, watch } from "vue"
  import { Combobox, ComboboxInput, ComboboxButton, ComboboxOptions, ComboboxOption, TransitionRoot } from "@headlessui/vue"

  interface Props {
    modelValue: any
    data: any
    name?: string
    multiple?: boolean
    placeholder?: string
    type?: "default" | string
    hasVisibility?: boolean
    inputDisabled?: boolean
    byValue?: boolean
    displaySelectedNames?: boolean
    capitalizedInputDisplay?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ComboBoxContainer',
  props: {
    modelValue: null,
    data: null,
    name: null,
    multiple: { type: Boolean },
    placeholder: null,
    type: null,
    hasVisibility: { type: Boolean },
    inputDisabled: { type: Boolean },
    byValue: { type: Boolean },
    displaySelectedNames: { type: Boolean },
    capitalizedInputDisplay: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as {
    modelValue: any
    data: any
    name?: string
    multiple?: boolean
    placeholder?: string
    type?: "default" | string
    hasVisibility?: boolean
    inputDisabled?: boolean
    byValue?: boolean
    displaySelectedNames?: boolean
    capitalizedInputDisplay?: boolean
  }

  
  const people = computed(() => props.data)

  

  const selectedList = computed({
    get: () =>
      typeof props.modelValue == "string"
        ? props.modelValue.length
          ? [props.modelValue]
          : []
        : typeof props.modelValue == "number"
        ? props.modelValue > 0
          ? [props.modelValue]
          : []
        : props.modelValue,
    set: (val) => emit("update:modelValue", typeof props.modelValue == "string" ? val : typeof props.modelValue == "number" ? parseInt(val, 10) : val),
  })
  const query = ref("")

  const filteredData = computed(() =>
    query.value === "" ? people.value : people.value.filter((person: { name: string }) => person.name.toLowerCase().replace(/\s+/g, "").includes(query.value.toLowerCase().replace(/\s+/g, "")))
  )

  const emptyList = async () => emit("update:modelValue", typeof props.modelValue == "string" ? "" : typeof props.modelValue == "number" ? 0 : [])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Combobox), {
    modelValue: _unref(selectedList),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedList) ? (selectedList).value = $event : null)),
    multiple: __props.multiple,
    name: __props.name || 'comboboxContainer'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createVNode(_unref(ComboboxInput), {
            class: _normalizeClass(
            __props.type === 'default'
              ? `bg-light-gray-100 h-[45px] rounded-base pl-5 pr-10 outline-none focus:bg-white focus:shadow-base focus:rounded-base w-full ${__props.capitalizedInputDisplay ? 'capitalize' : ''}`
              : 'h-[45px] w-full pl-10 pr-5 pt-3 outline-none focus:bg-white focus:shadow-base focus:rounded-base'
          ),
            "display-value": 
            (person) =>
              `${
                __props.displaySelectedNames
                  ? __props.data.filter((val) => `${val.value}` === `${person.value || person}`).length
                    ? __props.data.filter((val) => `${val.value}` === `${person.value || person}`)[0].name
                    : person.name || person
                  : person.name || person
              }`.replace(/,/g, ', ')
          ,
            placeholder: __props.hasVisibility && !_unref(selectedList).length ? 'Do not display' : __props.placeholder,
            disabled: __props.inputDisabled,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (query.value = $event.target.value))
          }, null, 8, ["class", "display-value", "placeholder", "disabled"]),
          _createVNode(_unref(ComboboxButton), {
            open: true,
            class: "absolute inset-y-0 right-0 flex flex-row-reverse items-center px-5 w-full"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(TransitionRoot), {
          leave: "transition ease-in duration-100",
          "leave-from": "opacity-100",
          "leave-to": "opacity-0",
          onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (query.value = ''))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ComboboxOptions), { class: "absolute mt-1 -mr-24 max-h-[190px] w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10" }, {
              default: _withCtx(() => [
                (_unref(filteredData).length === 0 && query.value !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Nothing found."))
                  : _createCommentVNode("", true),
                (__props.hasVisibility)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      "native-type": "button",
                      class: _normalizeClass(["relative font-medium cursor-pointer select-none py-2 px-5 text-left w-full hover:bg-primary-violet hover:text-white", (!_unref(selectedList).length && __props.multiple) || (!__props.multiple && !_unref(selectedList).length) ? '-pl-3' : 'pl-9']),
                      onClick: _withModifiers(emptyList, ["prevent"])
                    }, _toDisplayString((!_unref(selectedList).length && __props.multiple) || (!__props.multiple && !_unref(selectedList).length) ? "✔" : "") + " Do not display ", 11, _hoisted_6))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredData), (person) => {
                  return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                    key: person.id || person,
                    as: "template",
                    value: __props.byValue ? person.value : person
                  }, {
                    default: _withCtx(({ selected, active }) => [
                      _createElementVNode("li", {
                        class: _normalizeClass(["relative cursor-pointer select-none py-2 px-5 text-left before:w-fit", {
                'bg-primary-violet text-white': active,
                'text-gray-900': !active,
              }])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["block font-medium", 
                  selected || (!__props.multiple && _unref(selectedList).includes(__props.displaySelectedNames && __props.byValue ? (typeof __props.modelValue == 'number' ? parseInt(person.value, 10) : `${person.value}`) : person))
                    ? '-pl-3'
                    : 'pl-4'
                ])
                        }, _toDisplayString(selected || (!__props.multiple && _unref(selectedList).includes(__props.displaySelectedNames && __props.byValue ? (typeof __props.modelValue == "number" ? parseInt(person.value, 10) : `${person.value}`) : person))
                    ? "✔"
                    : "") + " " + _toDisplayString(person.name || person), 3)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "multiple", "name"]))
}
}

})